import { createSlice } from "@reduxjs/toolkit";

export const InvoiceSlice = createSlice({
    name: "invoiceSlice",
    initialState: {
        dateWiseInvoices: [],
        dateWisePaginateInvoice: {
            total_page_count: 1,
            data: []
        },
        allDueInvoices: [],
        paginateDueInvoices: {
            total_page_count: 1,
            data: []
        }
    },
    reducers: {
        getDateWiseInvoiceReducer: (state, action) => {
            state.dateWiseInvoices = action.payload
        },
        getAllDueInvoicesReducer: (state, action) => {
            state.allDueInvoices = action.payload
        },
        getDateWisePaginateInvoiceReducer: (state, action) => {
            state.dateWisePaginateInvoice = {
                total_page_count: action?.payload?.total_page_count || 1,
                data: action?.payload?.data || []
            }
        },
        getPaginateDueInvoiceReducer: (state, action) => {
            state.paginateDueInvoices = {
                total_page_count: action?.payload?.total_page_count || 1,
                data: action?.payload?.data || []
            }
        }
    }
})